module.exports = __webpack_public_path__ + "static/media/edin peko.59e5a614.png";